/**
 * Regeln fürs Passwort — eine Stelle für Server (Anlegen, Ändern) und App
 * (Formular). Zwei Zahlen an zwei Orten liefen auseinander, und das Formular
 * nähme an, was der Server ablehnt.
 */

export const MIN_PASSWORD_LENGTH = 12;
/** Obergrenze, damit ein sehr langes Passwort nicht zum Erschöpfungsangriff wird. */
export const MAX_PASSWORD_LENGTH = 200;

export type PasswordProblem = 'tooShort' | 'tooLong' | 'mismatch' | 'unchanged';

/** Prüft ein neues Passwort samt Wiederholung — `null` heißt: in Ordnung. */
export function checkNewPassword(
  next: string,
  repeat: string,
  current?: string,
): PasswordProblem | null {
  if (next.length < MIN_PASSWORD_LENGTH) return 'tooShort';
  if (next.length > MAX_PASSWORD_LENGTH) return 'tooLong';
  if (next !== repeat) return 'mismatch';
  if (current !== undefined && next === current) return 'unchanged';
  return null;
}
